var map = {
	"./flags/be.svg": 38,
	"./flags/cn.svg": 39,
	"./flags/de.svg": 40,
	"./flags/es.svg": 41,
	"./flags/fr.svg": 42,
	"./flags/gb.svg": 43,
	"./flags/it.svg": 44,
	"./flags/jp.svg": 45,
	"./flags/us.svg": 46,
	"./icons/back.svg": 47,
	"./icons/close.svg": 48,
	"./icons/error.svg": 49,
	"./icons/facebook.svg": 50,
	"./icons/info.svg": 51,
	"./icons/instagram.svg": 52,
	"./icons/link-arrow.svg": 53,
	"./icons/linkedin.svg": 54,
	"./icons/marker.svg": 55,
	"./icons/pinterest.svg": 56,
	"./icons/slider-arrow.svg": 57,
	"./icons/star.svg": 58,
	"./icons/success.svg": 59,
	"./icons/twitter.svg": 60,
	"./icons/weibo.svg": 61,
	"./icons/youtube.svg": 62,
	"./logo.svg": 63,
	"./noise.png": 64,
	"./shape.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;